import { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { ModalProps } from '../Modal/Modal'

export type HasScopeAction = (resource: string, scope: string, superScopes?: string[]) => boolean
export type HasQuotaAction = (quota: string) => boolean
export type CustomAuthAction = () => boolean
export type ZocksAuthActions = [HasScopeAction | CustomAuthAction | undefined, HasQuotaAction?]

export interface ScopeDescriptor {
  scope: string
  superScope: string[]
  resource?: string //defaults to **
}
export interface QuotaDescriptor {
  quota: string
  limitQuota?: string
}

export interface ScopedBlockProps extends PropsWithChildren {
  authActions?: ZocksAuthActions
  scope?: ScopeDescriptor
  quota?: QuotaDescriptor
  missingScopeAction: MissingScopeAction
  tooltipElement?: ReactNode
  tooltipText?: ReactNode
  tooltipButtonText?: string
  upgradeContainerClassName?: string
  showUpgradeBadge?: boolean
  modal?: ReactElement<ModalProps>
  replaceElement?: ReactNode
}

export enum MissingScopeAction {
  IGNORE = 'ignore',
  HIDE = 'hide',
  DISABLE = 'disable',
  UPGRADE = 'upgrade',
  MODAL = 'modal',
  REPLACE = 'replace',
}
